<template>
  <div>
    <c-search-form
        :rows-per-page-items="[10, 20, 50]"
        :form-name="formName"
        :fields="fields"
        key-property="procedureId"
        search-url="/procedureWh/search"
        create-url="/procedureWh/save"
        delete-url="/procedureWh/delete"
        form-type="intable"
        custom-create-new
        @createNew="openCreateDialog"
        custom-edit-item
        @editItem="openEditDialog"
        custom-copy-item
        @copyItem="openCopyDialog"
        @openMaterialListDialog="openMaterialListDialog"
        @openDayListDialog="openDayListDialog"
        @openHistoryDialog="openHistoryDialog"
        ref="tableData"
        :reload="timeReloadSearchForm"
        :acceptView="true"
        :deleteMulti="false"
        :acceptDelete="false"
        :acceptCopy="true"
        @viewItem="viewItem"
        @setLastSearchValues="setLastSearchValues"
        :lastSearchValues="lastSearchValues"

    >
    </c-search-form>
    <procedure-wh-create
        :propsItem="propsItemCreate"
        :cDialog="visibleCreateDialog"
        :areas="areas"
        :seedNumbers="seedNumbers"
        @closeDialog="closeCreateDialog"
        :formCreateName="formCreateName"/>
    <procedure-wh-material-list
        :propsItem="propsItemMaterial"
        :cDialog="visibleMaterialListDialog"
        :areas="areas"
        @closeDialog="closeMaterialListDialog"
        @deleteMaterialFromProcedure="deleteMaterialFromProcedure"
        @openMaterialCreateDialog="openMaterialCreateDialog"
        :timeReload="timeReloadMaterialList"

    />
    <procedure-wh-material-create
        :propsItem="propsItemMaterial"
        :cDialog="visibleMaterialCreateDialog"
        :areas="areas"
        :reload-create="timeReloadCreate"
        @closeDialog="closeMaterialCreateDialog"/>
    <feature-log ref="featureDlg"/>
    <!--        <procedure-wh-day-list-->
    <!--                :propsItem="propsItemDay"-->
    <!--                :cDialog="visibleDayListDialog"-->
    <!--                :areas="areas"-->
    <!--                @closeDialog="closeDayListDialog"-->
    <!--                :timeReload="timeReload" />-->

    <!--        <procedure-wh-day-list-view-->
    <!--            :propsItem="propsItemDay"-->
    <!--            :cDialog="visibleDayListViewDialog"-->
    <!--            :areas="areas"-->
    <!--            @closeDialog="closeDayListViewDialog"-->
    <!--            :timeReload="timeReload" />-->


  </div>
</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import {areaContants} from "@/constants";
import ProcedureWhCreate from "./ProcedureWhCreate";
import axios from "axios";
import ProcedureWhMaterialList from "./ProcedureWhMaterialList";
import ProcedureWhMaterialCreate from "./ProcedureWhMaterialCreate";
import ProcedureWhDayList from "./ProcedureWhDayList";
import ProcedureWhDayListView from "./ProcedureWhDayListView";
import {router} from "../../../router";
import FeatureLog from "../FeatureLog";

export default {
  name: "procedure-wh-list",
  components: {
    FeatureLog,
    ProcedureWhDayList, ProcedureWhDayListView,
    ProcedureWhMaterialCreate, ProcedureWhMaterialList, ProcedureWhCreate, CSearchForm
  },
  data: () => {
    return {
      formName: "Danh sách quy trình nuôi",
      formCreateName: "Thêm mới quy trình",
      propsItemCreate: null,
      propsItemMaterial: null,
      propsItemDay: null,
      areas: [],
      seedNumbers: [],
      visibleCreateDialog: false,
      visibleMaterialListDialog: false,
      visibleMaterialCreateDialog: false,
      visibleDayListDialog: false,
      visibleDayListViewDialog: false,
      timeReloadSearchForm: 0,
      timeReloadMaterialList:0,
      timeReloadCreate:0,
      lastSearchValues: {},
      fields: [
        {
          value: "index",
          text: "lang.common.index",
          width: "5%",
          sortable: false,
          headerStyle: "text-align:center",
        },
        {
          value: "codeIncludeNote",
          text: "Mã quy trình",
          width: "25%",
          sortable: false,
          search: true,
          headerStyle: "text-align:center",
        },
        {
          value: "areaId",
          text: "Khu nuôi",
          width: "15%",
          search: true,
          headerStyle: "text-align:center",
          type: "select",
          name: "areaId",
          items: [],
          itemText: "categoryCode",
          itemValue: "categoryId",
        },
        {
          value: "note",
          text: "Ghi chú",
          width: "20%",
          sortable: false,
          search: true,
          headerStyle: "text-align:center",
        },
        {
          value: "status",
          text: "lang.user.status",
          width: "15%",
          search: true,
          headerStyle: "text-align:center",
          type: "select",
          name: "status",
          items: areaContants.areaStatus,
          itemText: "text",
          itemValue: "value",
        },
        {
          value: 'custom_action_list',
          text: "Vật tư",
          width: "60px",
          items: [
            {
              text: "Vật tư",
              icon: "format_list_bulleted",
              event: "openMaterialListDialog",
              color: "primary"
            },
          ],

        },
        {
          value: 'custom_action_list',
          text: "Chỉ số",
          width: "60px",
          items: [
            {
              text: "Chỉ số",
              icon: "pie_chart",
              event: "openDayListDialog",
              color: "primary"
            },
          ],

        },
        {
          value: 'custom_action_list',
          text: "Lịch sử",
          width: "60px",
          items: [
            {
              text: "Chỉ số",
              icon: "mdi-history",
              event: "openHistoryDialog",
              color: "primary"
            },
          ],

        },
        {
          value: "action",
          text: "lang.common.actions",
          sortable: false,
          compound: true,
          width: "200px",
          headerStyle: "text-align:center",
        },
      ],
    };
  },

  created() {
    this.lastSearchValues = this.$route.query;
    axios
        .post(
            process.env.VUE_APP_API_URL +
            "/category/listByTypeAuthenticateArea?type=PONDAREA"
        )
        .then((data) => {
          if (data.length > 0) {
            this.areas = data;
            let itemFields = this.fields.filter(function (e) {
              return e.name == "areaId";
            });
            if (itemFields != undefined && itemFields.length > 0) {
              itemFields[0].items = data;

            }
          }
        });

    // số lượng giống
    axios.post(
        process.env.VUE_APP_API_URL + "/category/listByType?type=SEEDNUMBER"
    )
        .then(
            (data) => {
              if (data.length > 0) {
                this.seedNumbers = data;
                // let itemFields = this.fields.filter(function (e) {
                //     return e.name == "seedNumber";
                // });
                // if (itemFields != undefined && itemFields.length > 0) {
                //     itemFields[0].items = data;
                // }
              }
            }
        );
  },
  methods: {
    setLastSearchValues: function (values) {
      this.lastSearchValues = Object.assign(this.lastSearchValues, values);
    },
    openCreateDialog: function (item = null) {
      this.propsItemCreate = item;
      this.visibleCreateDialog = true;
      if (item != null) {
        this.formCreateName = 'Thêm mới quy trình';
      }
    },

    openEditDialog: function (item = null) {
      //this.propsItemCreate = item;
      this.propsItemCreate = Object.assign({}, item, {"isEditForm": true})
      this.visibleCreateDialog = true;
      if (item != null) {
        this.formCreateName = 'Cập nhật quy trình';
      }
    },

    openHistoryDialog(item = null){
      console.log(item);
      if(item == null){
        return;
      }
      this.$refs.featureDlg.onSearch("procedure",item.procedureId);

    },

    openCopyDialog: function (item = null) {
      //this.propsItemCreate = item;
      this.propsItemCreate = Object.assign({}, item, {"isCopy": true, "seedNumber": null, "code": null})
      console.log("openCopyDialog " + JSON.stringify(this.propsItemCreate))
      this.visibleCreateDialog = true;
      if (item != null) {
        this.formCreateName = 'Sao chép quy trình';
      }
    },

    closeCreateDialog: function () {
      this.propsItemCreate = null;
      this.visibleCreateDialog = false;
      this.timeReloadSearchForm = Math.random();
    },

    openMaterialListDialog(item) {
      this.propsItemMaterial = item;
      this.visibleMaterialListDialog = true;
    },
    closeMaterialListDialog: function () {
      this.propsItemMaterial = null;
      this.visibleMaterialListDialog = false;
    },
    deleteMaterialFromProcedure: function () {
      //this.timeReloadCreate = Math.random();
    },
    openMaterialCreateDialog() {
      this.visibleMaterialCreateDialog = true;
      this.timeReloadCreate = Math.random();
    },
    closeMaterialCreateDialog: function () {
      this.visibleMaterialCreateDialog = false
      this.timeReloadMaterialList = Math.random();

    },

    openDayListDialog(item) {

      this.propsItemDay = item;

      this.visibleDayListDialog = true;
      //alert(`/procedureDayList/edit/` + item.procedureId);
      //router.push(`/procedureDayList/edit/` + item.procedureId);

      router.push({ path: `/procedureDayList/edit/` + item.procedureId, query: this.lastSearchValues });


    },
    closeDayListDialog: function () {
      this.propsItemDay = null;
      this.visibleDayListDialog = false;
    },
    viewItem: function (item = null) {
      this.propsItemDay = item;

      //router.push(`/procedureDayList/view/` + item.procedureId);
      router.push({ path: `/procedureDayList/view/` + item.procedureId, query: this.lastSearchValues });

      //this.visibleDayListViewDialog = true;
    },
    closeDayListViewDialog: function () {
      this.propsItemDay = null;
      this.visibleDayListViewDialog = false;
    },
  },

  destroyed() {
  },
};
</script>
